import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🔗 External Node Modules

HawkClient allows you to use **external Node.js modules** inside your scripts, provided they are installed within the **collection folder**.

### 📦 Requirements
To use an external module:
- The module must be installed **inside the collection directory**
- A valid \`package.json\` must be present
- The module should be importable using standard Node.js syntax

---

## 🎲 Example: Using \`faker\`

You can install packages like **\`faker\`** to generate dynamic request data such as random names, emails, or IDs.

Once installed, the module can be imported directly inside your pre-request or post-response scripts.

![External Node Modules Example](/scripts/ScriptOverview.png)
`;

const ExternalNodeModules = () => {
    return (
        <MarkDownRenderer
            title="External Node Modules"
            markDownText={markdownContent}
        />
    );
};

export default ExternalNodeModules;
